export const getAbout = async (locale) => {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/about`, {
    headers: {
      "Accept-Language": locale,
    },
  });
  return res.json();
};
